import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';
import { DomUtils } from '../../utils/dom-utils';
import { IconSizes } from '../Icons';
import { CustomTooltip } from '../Poppers';
import { Themes } from '../../style/theme-consts';
import { IconButtonVariants } from './consts';

export { IconButtonVariants } from './consts';

const IconButton = ({
  icon: IconComponent,
  disabled,
  selected,
  onClick,
  isLoading,
  rotate,
  iconSize = IconSizes.M,
  count,
  testId = 'icon-button',
  variant = IconButtonVariants.FILLED,
  className,
  tooltip
}) => {
  const { theme, elementRef } = DomUtils.useDetectParentTheme();

  const onClickHandler = e => {
    if (disabled || isLoading) return;
    onClick?.(e);
  };
  const element = (
    <S.IconButton
      ref={tooltip ? elementRef : null}
      $variant={variant}
      disabled={disabled}
      $selected={selected}
      onClick={onClickHandler}
      $loading={isLoading}
      className={className}
      data-testid={testId}>
      <IconComponent
        className="icon-button-icon-color"
        fontSize={iconSize}
        color={isLoading ? 'var(--icon-button-bg-color)' : 'var(--icon-button-icon-color)'}
        disabled={disabled}
        rotate={rotate}
      />
      {isLoading ? <S.InProgress size={16} rotate color="var(--button-loading-icon-color)" /> : null}
      {count && !isLoading && !disabled ? <S.Count>{count}</S.Count> : null}
    </S.IconButton>
  );

  return tooltip ? (
    <CustomTooltip placement="bottom" title={tooltip} mode={theme || Themes.LIGHT} arrow={false}>
      {element}
    </CustomTooltip>
  ) : (
    element
  );
};
IconButton.propTypes = {
  icon: PropTypes.elementType,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  rotate: PropTypes.bool,
  variant: PropTypes.oneOf(['FILLED', 'SECONDARY', 'OUTLINED', 'NAKED']),
  count: PropTypes.number,
  testId: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconButton;
